document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('MenuToggle');
  const overlay = document.getElementById('MenuOverlay');
  const closeBtn = document.getElementById('MenuClose');

  if (!toggle || !overlay) return;

  function openMenu() {
    overlay.classList.add('is-active');
  }

  function closeMenu() {
    overlay.classList.remove('is-active');
  }

  toggle.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
});